import { type FC } from 'react';

import { IconButton } from '@chakra-ui/react';

import { DeleteMerchantButton } from '@features/merchant';

import { Icons, Menu, MenuButton, MenuList } from '@shared/ui-kit';

interface Props {
  merchantId: string;
}

const MoreActions: FC<Props> = ({ merchantId }) => {
  return (
    <Menu autoSelect={false}>
      <MenuButton
        className="fg-of-link"
        size="sm"
        as={IconButton}
        icon={
          <Icons.More
            color="gray.700"
            transform="rotate(90deg)"
          />
        }
        bg="transparent"
        _hover={{ bg: 'gray.200' }}
        _focus={{ bg: 'gray.300' }}
        _active={{ bg: 'gray.300' }}
      />
      <MenuList>
        <DeleteMerchantButton merchantId={merchantId} />
      </MenuList>
    </Menu>
  );
};

export default MoreActions;
